import { Component } from "@angular/core";
import { SHARED } from "src/app/shared/shared";

@Component({
  selector: "dentr-privacy-policy-au",
  templateUrl: "./privacy-policy-au.component.html",
  standalone: true,
  imports: [SHARED],
})
export class PrivacyPolicyAUComponent {}
